import { Helmet } from "react-helmet-async";
import HeroSection from "@/components/HeroSection";
import ServicesSection from "@/components/ServicesSection";
import ProcessSection from "@/components/ProcessSection";
import TestimonialsSection from "@/components/TestimonialsSection";
import FAQSection from "@/components/FAQSection";
import Footer from "@/components/Footer";
import StickyCTA from "@/components/StickyCTA";
import { useState } from "react";

const Chicago = () => {
  const handleBookingClick = () => {
    // Navigate to booking page for now
    window.location.href = '/book';
  };

  return (
    <>
      <Helmet>
        <title>Professional Home Organizer Chicago | Organize by Design</title>
        <meta 
          name="description" 
          content="Expert home organization services in Chicago. Luxury organizing for Lincoln Park, River North, Gold Coast. Transform your Chicago home with our professional organizers." 
        />
        <meta name="keywords" content="professional organizer Chicago, home organization Chicago, luxury organizing Lincoln Park, River North organizer, Gold Coast home organization" />
        <link rel="canonical" href="https://organizebydesign.com/chicago" />
        
        {/* Local Business Schema */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "LocalBusiness",
            "name": "Organize by Design - Chicago",
            "description": "Professional home organization services in Chicago",
            "address": {
              "@type": "PostalAddress",
              "addressLocality": "Chicago",
              "addressRegion": "IL",
              "addressCountry": "US"
            },
            "areaServed": {
              "@type": "City",
              "name": "Chicago",
              "sameAs": "https://en.wikipedia.org/wiki/Chicago"
            },
            "serviceType": "Home Organization Services",
            "priceRange": "$$-$$$"
          })}
        </script>
      </Helmet>

      <main>
        <HeroSection onBookingClick={handleBookingClick} />
        <ServicesSection onBookingClick={handleBookingClick} />
        <ProcessSection />
        <TestimonialsSection />
        <FAQSection />
        <Footer onBookingClick={handleBookingClick} />
        <StickyCTA onClick={handleBookingClick} />
      </main>
    </>
  );
};

export default Chicago;